import { WorkspaceDatabaseKeys } from '@database/workspace';
import { ErrorCodes, fileBooleanMappings } from '@shared';
import { firstValueFrom, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DeleteIntervalService } from '../services';
import { ValidationKeys } from '../../../../dynamic-form/validations/models';
import { DeleteChainParams, IDeleteValidatorHandler, IValidationsRule } from './models';
import { LoggingService } from '@shared/logging';

export class StartAtZeroCheck implements IDeleteValidatorHandler {
	private next: IDeleteValidatorHandler;

	public constructor(
		private deleteDataService: DeleteIntervalService,
		private loggerService: LoggingService
	) {}

	public setNext(nextHandler: IDeleteValidatorHandler) {
		this.next = nextHandler;
	}

	public async handle(deleteChainParams: DeleteChainParams): Promise<IValidationsRule | null> {
		try {
			const startAtZeroValidation: IValidationsRule | null = await firstValueFrom(
				of(
					fileBooleanMappings[
						deleteChainParams.tableMetadata[WorkspaceDatabaseKeys.tables.dataMustStartAtZero]
					]
				).pipe(
					switchMap((mustStartAtZero: boolean) => {
						if (mustStartAtZero) {
							return this.deleteDataService
								.isDeleteStartAtZeroForbidden$(
									deleteChainParams.tableName,
									deleteChainParams.workfileId,
									deleteChainParams.projectNumber,
									deleteChainParams.entityName,
									deleteChainParams.entryId,
									deleteChainParams.childEntryId
								)
								.pipe(
									map((isDeleteZeroForbidden: boolean) =>
										isDeleteZeroForbidden
											? { validationKey: ValidationKeys.validationRules.startAtZeroRule }
											: null
									)
								);
						}
						return of(null);
					})
				)
			);

			if (startAtZeroValidation) {
				return startAtZeroValidation;
			}

			if (this.next) {
				return await this.next.handle(deleteChainParams);
			}

			return null;
		} catch (error) {
			this.loggerService.error(ErrorCodes.DeleteStartAtZeroError, error);
			throw error;
		}
	}
}
